import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8 11.75h6a.75.75 0 0 0 0-1.5H8a.75.75 0 1 0 0 1.5M14 14.75H8a.75.75 0 0 1 0-1.5h6a.75.75 0 1 1 0 1.5M8 17.75h4.33a.75.75 0 0 0 0-1.5H8a.75.75 0 1 0 0 1.5" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17 21.75H7A2.75 2.75 0 0 1 4.25 19V5A2.75 2.75 0 0 1 7 2.25h7.17a2.74 2.74 0 0 1 2 .81l2.82 2.82a2.74 2.74 0 0 1 .81 2V19a2.75 2.75 0 0 1-2.8 2.75m-10-18A1.25 1.25 0 0 0 5.75 5v14A1.25 1.25 0 0 0 7 20.25h10A1.25 1.25 0 0 0 18.25 19V8.75H15A1.75 1.75 0 0 1 13.25 7V3.75zm10.88 3.19q.139.137.23.31H15a.25.25 0 0 1-.25-.25V3.89c.114.06.22.138.31.23z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }